export const lightTheme = {
  text: {
    primary: "#212121",
    secondary: "#bababa",
  },
  background: {
    primary: "#FFFFFF",
    secondary: "#F5F5F5",
    tertiary: "#C4C4C4",
    cuartiary: "#E9E9E9",
    gray: "#f5f5f5",
    yellow: "#fff1e6",
    blue: "#dfe7fd",
    lightblue: "#9cbced",
    violet: "#eae4e9",
    red: "#fad2e1",
    cardGray: "#e6ecf2",
  },
  button: {
    primary: "#023e8a",
    textPrimary: "#FFFFFF",
    hoverPrimary: "#00469E",
    secondary: "#3F3F3F",
    textSecondary: "#FFFFFF",
    hoverSecondary: "#2F2F2F",
    tertiary: "#C4C4C4",
    textTertiary: "#000000",
    hoverTertiary: "#939393",
    cuartiary: "#E9E9E9",
    textCuartiary: "#000000",
    hoverCuartiary: "#939393",
  },
  svg: {
    primary: "#000000",
    hoverPrimary: "#FFFFFF",
    secondary: "#ffffff",
    hoverSecondary: "#FFFFFF",
    background: "#3F3F3F",
    hoverBackground: "#000000",
  },
};
export const darkTheme = {
  text: {
    primary: "#ffffff",
    secondary: "#529bf5",
  },
  background: {
    primary: "#121212",
    secondary: "#222222",
    tertiary: "#C4C4C4",
    cuartiary: "#383f45",
    gray: "#3b3b3b",
    yellow: "#ffa000",
    blue: "#303f9f",
    lightblue: "#023e8a",
    violet: "#673ab7",
    red: "#c62828",
    cardGray: "#8EABC8",
  },
  button: {
    primary: "#4284e4",
    textPrimary: "#FFFFFF",
    hoverPrimary: "#316dca",
    secondary: "#ffffff",
    textSecondary: "#121212",
    hoverSecondary: "#dfe7fd",
    tertiary: "#C4C4C4",
    textTertiary: "#000000",
    hoverTertiary: "#939393",
    cuartiary: "#E9E9E9",
    textCuartiary: "#000000",
    hoverCuartiary: "#939393",
  },
  svg: {
    primary: "#ffffff",
    hoverPrimary: "#121212",
    secondary: "#ffffff",
    hoverSecondary: "#FFFFFF",
    background: "#3F3F3F",
    hoverBackground: "#ffffff",
  },
};
